import React from 'preact/compat';
import PropTypes from 'prop-types';

import importComponent from '../../lib/importComponent';

import { locales as LOCALES } from '../../data/locales';

const components = {
  CompanyJobs:
    async () => (await import('../JobsEmbeder/Company/Jobs')).default,
  HomePageJobs:
    async () => (await import('../JobsEmbeder/HomePage/Jobs')).default,
  HighlightedJobs:
    async () => (await import('../JobsEmbeder/HighlightedJobs/Jobs')).default,
  SearchJobs:
    async () => (await import('../JobsEmbeder/Search/Jobs')).default,
};

const Jobs = (props) => {
  const JobComponent =
    importComponent(components[props.component]);

  return (
    <div className="Jobs">
      <JobComponent {...props} />
    </div>
  );
};

Jobs.propTypes = {
  component: PropTypes.string,
};

Jobs.defaultProps = {
  component: 'CompanyJobs',
};

const JobsList = ({
  dataLocales,
  dataLimit,
  dataOffset,
  dataKeywords,
  dataCategory,
  dataProfile_id: profileId,
  dataCity,
  dataComponent,
  dataHighlight_locale: highlightLocale,
  dataInterval,
}) => (<Jobs
  locales={dataLocales ? dataLocales.split(',') : LOCALES}
  limit={Number(dataLimit)}
  offset={Number(dataOffset)}
  keywords={dataKeywords}
  category={dataCategory}
  profileId={profileId}
  city={dataCity}
  highlightLocale={highlightLocale}
  component={dataComponent}
  interval={Number(dataInterval)}
/>);

JobsList.propTypes = {
  dataLocales: PropTypes.string,
  dataLimit: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  dataOffset: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  dataKeywords: PropTypes.string,
  dataCategory: PropTypes.string,
  dataProfile_id: PropTypes.string,
  dataCity: PropTypes.string,
  dataHighlight_locale: PropTypes.string,
  dataComponent: PropTypes.string,
  dataInterval: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

JobsList.defaultProps = {
  dataLocales: undefined,
  dataLimit: 10,
  dataOffset: 0,
  dataKeywords: undefined,
  dataCategory: undefined,
  dataProfile_id: undefined,
  dataCity: undefined,
  dataHighlight_locale: undefined,
  dataComponent: undefined,
  dataInterval: 2000,
};

export default JobsList;
